export type RenewalBucket = 'overdue' | 'd0_15' | 'd16_30' | 'd31_60' | 'later';

export interface RenewalRow {
  id: string;
  dealId: string;
  branchId: string;
  branchName: string;
  assigneeMemberId: string | null;
  assigneeName: string | null;
  dueOn: string;
  daysLeft: number;
  bucket: RenewalBucket;
  status: string;
  expectedBrokeragePaise: number | null;
  nextDealId: string | null;
  partiesOptIn: boolean;
  propertyTitle: string;
  clientName: string;
  /** Masked (with asterisks) when the role may not see client phones. */
  tenantPhone: string | null;
  ownerName: string | null;
  ownerPhone: string | null;
}

export const RENEWAL_STATUSES = [
  'upcoming',
  'contacted',
  'renewing',
  'renewed_here',
  'renewed_elsewhere',
  'tenant_leaving',
  'unknown',
] as const;

export const RENEWAL_TABS = ['overdue', 'd0_15', 'd16_30', 'd31_60'] as const;
export type RenewalTab = (typeof RENEWAL_TABS)[number];

/** The money the broker can expect from renewals falling due in the next 60 days (not the overdue). */
export function renewalHero(rows: RenewalRow[]): { paise: number; count: number } {
  const coming = rows.filter((r) => r.bucket !== 'overdue' && r.bucket !== 'later');
  return {
    paise: coming.reduce((sum, r) => sum + (r.expectedBrokeragePaise ?? 0), 0),
    count: coming.length,
  };
}

/** The first tab worth showing: overdue when there is any, else the nearest group with something in it. */
export function firstTab(rows: RenewalRow[]): RenewalTab {
  return RENEWAL_TABS.find((tab) => rows.some((r) => r.bucket === tab)) ?? 'd0_15';
}

/** A number that can be called: present and not masked. */
export function callable(phone: string | null): string | null {
  return phone === null || phone.includes('*') ? null : phone;
}
